import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proactive',
  templateUrl: './proactive.component.html',
  styleUrls: ['./proactive.component.css']
})
export class ProactiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
